import { SpinAndHoldCommonConfiguration } from "../../../api";
import { ResourceIdentifier } from "../../../ResourceManager/ResourceIdentifier";
import { SpinAndHold2 } from "../SpinAndHold/SpinAndHold2";
import { SpinAndHold2Params } from "../SpinAndHold/SpinAndHold2Params";

export class BigSymbolSpinAndHold2 extends SpinAndHold2
{
    protected override BonusName(): string
	{
		return "BigSymbolSpinAndHold";
	}

    public constructor(gameResid: ResourceIdentifier, params: SpinAndHold2Params, config: SpinAndHoldCommonConfiguration)
    {
        super(gameResid, params, config);
    }

}